// Icon components for carousel items
import { FaChalkboardTeacher, FaUserCheck, FaClipboardList, FaBookOpen, FaTrophy, FaGlobe } from "react-icons/fa";

export const carouselIcons = [
  FaChalkboardTeacher,
  FaUserCheck,
  FaClipboardList,
  FaBookOpen,
  FaTrophy,
  FaGlobe
];
